import React, { Component } from 'react';
import { Col, Row } from 'antd';
import QueueAnim from 'rc-queue-anim';
import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';
import { Link } from 'react-router-dom'
import CaseImage from '../common/caseImage'
import axios from "axios"

const baseURL = process.env.REACT_APP_API_URL;

class Case extends Component {
    constructor(props) {
        super(props);
        this.state = {
            grid: 1,
            cases: props.cases || [],
            case_id: props.match.params.case_id,
            pics: [],
            relate_cases: [],
        };
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ grid: nextProps.grid, case_id: nextProps.match.params.case_id });
        // axios.get(`http://www.as-gold.net/api/pics.php?case_id=` + nextProps.match.params.case_id).then(res => {
        //     const pics = res.data;
        //     this.setState({ pics: pics, isLoading: false });
        // })
        let filters = [];
        let filter = {field:"caseId",value:nextProps.match.params.case_id,operator:"inteq"};
        filters.push(filter)
        let orderBy = "sort desc";
        let param = {
            filters: filters,
            orderBy: orderBy
        };debugger
        axios.post(baseURL + 'pics/list',param).then(res => {
            const pics = res.data.list;
            this.setState({ pics: pics, isLoading: false });
        })
    }
    componentDidMount() {
        // axios.get(`http://www.as-gold.net/api/pics.php?case_id=` + this.state.case_id).then(res => {
        //     const pics = res.data;
        //     this.setState({ pics: pics, isLoading: false });
        // })
        let filters = [];
        let filter = {field:"caseId",value:this.state.case_id,operator:"inteq"};
        filters.push(filter)
        axios.post(baseURL + 'pics/list', {filters:filters}).then(res => {
            const pics = res.data.list;
            this.setState({ pics: pics, isLoading: false });
        })
    }
    render() {
        var case_id = this.state.case_id;
        var _case = null;
        this.state.cases.forEach(element => {
            if (element.id == case_id) {
                _case = element;
            }
        });
        var related_ids = _case.relatedIds.split(",");
        var related_cases = [];
        related_ids.forEach(related_id => {
            this.state.cases.forEach(element => {
                if (related_id == element.id) {
                    related_cases.push(element);
                }
            });
        });
        
        return (
            <QueueAnim type={['right', 'left']} leaveReverse>
                <div className="case-content" key="case-content">
                    <h1><Texty>{_case.name}</Texty></h1>
                    <Row gutter={8}>
                        <QueueAnim type="right" delay={1000}>
                            <Col key="p" xs={24} sm={22} md={20} lg={18} xl={16}>
                                <p>
                                    {_case.description}  </p>
                            </Col>
                        </QueueAnim>
                    </Row>
                    <Row gutter={8}>
                        <QueueAnim type="alpha" duration={500} delay={2500}>
                            {this.state.pics.map(item => (
                                <Col key={item.id} xs={24 * this.state.grid} sm={24 * this.state.grid} md={24 * this.state.grid} lg={12 * this.state.grid} xl={12 * this.state.grid}>
                                    <CaseImage key={item.id} src={item.url} style={{ marginTop: 8, width: "100%" }} />
                                </Col>
                            ))}
                        </QueueAnim>
                    </Row>
                    <div style={{ margin: 16 }} />
                    <QueueAnim type="right" duration={500} delay={1500}>
                        {_case.artDirection && _case.artDirection.length > 0 ? <h3 key="ad">艺术指导   : {_case.artDirection}</h3> : ""}
                        {_case.productDesign && _case.productDesign.length > 0 ? <h3 key="pd">产品设计   : {_case.productDesign}</h3> : ""}
                        {_case.client && _case.client.length > 0 ? <h3 key="c">客户   : {_case.client}</h3> : ""}
                    </QueueAnim>

                    <div style={{ margin: 64 }} />
                    {related_cases.length > 0 ?
                        <Row gutter={8}>
                            <h3 >相关设计:</h3>
                            <QueueAnim type="left" leaveReverse delay={2500}>
                                {related_cases.map(item => (
                                    <Col key={item.id} xs={6} sm={6} md={6} lg={4} xl={4}>
                                        <Link to={"/case/" + item.id}>
                                            <img key={item.id} alt={item.name} src={item.thumbnail} style={{ width: "100%" }} />
                                        </Link>
                                    </Col>
                                ))
                                }
                            </QueueAnim>
                        </Row>
                        : ""}

                </div>
            </QueueAnim>
        );
    }
}

export default Case;
